<template>
    <div class="bg-white p-3 radius-8 mt-3">
        <div class="row gy-4">
            <!-- TABLE -->
            <div class="col-12">
                <div class="table-responsive">
                    <table class="table align-middle">
                        <thead>
                        <tr>
                            <th scope="col">SL No</th>
                            <th scope="col">{{ service.service_request_table?.table_head_title ?? '' }}</th>
                            <th scope="col">Yes</th>
                            <th scope="col">No</th>
                        </tr>
                        </thead>

                        <tbody>
                        <tr v-for="(item, qIndex) in service.service_request_table?.service_table_details"
                            :key="qIndex">
                            <td>{{ qIndex + 1 }}.</td>
                            <td>{{ item.question ?? '' }}</td>

                            <!-- YES -->
                            <td>
                                <div class="form-check">
                                    <input
                                        class="form-check-input"
                                        type="checkbox"
                                        :checked="responses.table_answers[item.question] === 'yes'"
                                        @click="toggleTable(item.question, 'yes')"
                                    />
                                </div>
                            </td>
                            <!-- NO -->
                            <td>
                                <div class="form-check">
                                    <input
                                        class="form-check-input"
                                        type="checkbox"
                                        :checked="responses.table_answers[item.question] === 'no'"
                                        @click="toggleTable(item.question, 'no')"
                                    />
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- INPUTS -->
            <div class="col-lg-6 col-md-6"
                 v-for="(inputField, iIndex) in service.service_input"
                 :key="iIndex">

                <div class="form-group">
                    <label class="text-18">
                        {{ inputField.input_value ?? '' }}
                    </label>

                    <input
                        type="text"
                        class="form-control"
                        v-model="responses.inputs[inputField.input_value]"
                        placeholder="Enter Text"
                    />
                </div>
            </div>

            <!-- CHECKBOX (single-select) -->
            <div class="col-lg-6 col-md-6">
                <div class="form-group">
                    <label class="text-18">Verification type</label>

                    <div class="d-flex align-items-center gap-3 flex-sm-row flex-column">
                        <div
                            class="form-check p-3 radius-8 bg-color w-100"
                            v-for="(checkItem, cIndex) in service.service_checkbox"
                            :key="cIndex"
                        >

                            <label class="form-check-label text-16 fw-normal lh-1 m-0 w-100">
                                {{ checkItem.checkbox_value ?? '' }}
                            </label>

                            <input
                                class="form-check-input"
                                type="checkbox"
                                :checked="responses.checkboxes[checkItem.checkbox_value] === true"
                                @click="toggleCheckbox(checkItem.checkbox_value)"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    service: Object,
    responses: Object
});

const toggleTable = (question, value) => {
    if (props.responses.table_answers[question] === value) {
        props.responses.table_answers[question] = null
    } else {
        props.responses.table_answers[question] = value
    }
}

// const toggleCheckbox = (value) => {
//     if (props.responses.checkboxes.selected === value) {
//         props.responses.checkboxes.selected = null
//     } else {
//         props.responses.checkboxes.selected = value
//     }
// }

const toggleCheckbox = (selectedLabel) => {
    props.service.service_checkbox.forEach(item => {
        props.responses.checkboxes[item.checkbox_value] = false;
    });

    props.responses.checkboxes[selectedLabel] = true;
};

</script>
